import { Injectable, inject } from '@angular/core';

import {
    RdsToastIndividualConfig,
    RdsToastService,
    RdsToastType,
} from '@rds/angular-components';

@Injectable({
    providedIn: 'root',
})
export class NotifyService {
    private readonly rdsToastService = inject(RdsToastService);

    notification(title: RdsToastType, message: string, time = 3) {
        const options: RdsToastIndividualConfig = {
            actionButton: null,
            announcementMessage: null,
            closeButton: false,
            disableTimeOut: false,
            easeTime: 300,
            easing: '',
            enableHtml: false,
            extendedTimeOut: 2000,
            icon: null,
            iconNamespace: null,
            messageClass: '',
            newestOnTop: false,
            onActionButton: null,
            onActivateTick: false,
            politeness: 'off',
            position: 'bottom-right',
            tapToDismiss: false,
            timeOut: time * 1000,
            titleClass: '',
            toastClass: 'rds-toast',
            type: title
        };

        return this.rdsToastService.show(message, title, options);
    }
}
